import axios from "axios";
import { User } from "../interfaces/user";

export function getToken() {
    let token = localStorage.getItem('token');
    token = token ?? '';
    return token;
}

export function getUser(s: string = '', club: string = '', role: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (club.length > 0) {
        params.push('club=' + club);
    }
    if (role.length > 0) {
        params.push('role=' + role);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getUserSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user/' + id;
    return axios.get(getEventsUrl, { headers: headers } );
}

export function whoami() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user/me';
    return axios.get(getEventsUrl, { headers: headers } );
}

export function resetPassword(user_id: string, password: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Content-Type': 'application/json'
    }
    const body_obj = {
        user_id: user_id,
        password: password
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user/reset-password';
    return axios.post(getEventsUrl, JSON.stringify(body_obj), { headers: headers } );
}

export function requestResetPassword(email: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Content-Type': 'application/json'
    }
    const body_obj = {
        email: email
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user/request-reset-password';
    return axios.post(getEventsUrl, JSON.stringify(body_obj), { headers: headers } );
}

export function createUser(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateUser(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateUserProfile(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user-profile';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteUser(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function getUserWearables() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/user/wearable';
    return axios.get(endpointUrl, { headers: headers } );
}

export function getGarminConnectToken(code: string, code_verifier: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const body_obj = {
        code: code,
        code_verifier: code_verifier,
        redirect_url: window.location.protocol + '//' + window.location.host
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/get-garmin-connect-token';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}